
/* injects from baggage-loader */
var Template = require('./template.js');
require('./style.scss');

const ErrorNotFoundPage = (props) => Template.default.apply({props}); //eslint-disable-line no-undef
export default ErrorNotFoundPage;